import { Carriers } from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import {
  FulfillmentOrderAddressSchema,
  type IFulfillmentOrderAddress,
} from "@redotech/redo-model/fulfillments/fulfillment-order-address";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getOriginAddresses = {
  name: "getOriginAddresses" as const,
  input: z.object({ carrier: createEnum(Carriers) }),
  output: z.object({
    addresses: z.array(
      FulfillmentOrderAddressSchema as IFulfillmentOrderAddress,
    ),
  }),
};
